module.exports = __webpack_public_path__ + "img/siji.dae28cf2.svg";